import type { AxiosRequestConfig } from 'axios';

import type { ApiError } from './api-error';
import { getHttp } from './http';

/**
 * orval "mutator": every generated request function calls this with the operation's
 * axios config. It resolves with the response body exactly as the backend sends it (bare
 * objects, `{ items, nextCursor }` for lists) and rejects with ApiError only, never a raw
 * AxiosError.
 */
export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  return getHttp()
    .request<T>({ ...config, ...options })
    .then(({ data }) => data);
};

/** Type orval uses for the error branch of generated functions. */
export type ErrorType<_Error = unknown> = ApiError;

/** Type orval uses for request bodies. */
export type BodyType<Body> = Body;
